import {Component, Input, OnInit} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {DataService} from '../../services/data.service';
import {ApplicationService} from '../../services/application.service';
import {EnumerationService} from '../../services/enumeration.service';
import {ExcSecurityService} from 'exc-security-v2';
import {ExgModalService, ExgOverlayService} from 'exc-controls-v2';
import {ExcRestService} from 'exc-rest-v2';

@Component({
  selector: 'app-overlay-report-preview',
  templateUrl: './overlay-report-preview.component.html',
  styles: [
  ]
})
export class OverlayReportPreviewComponent extends ExcTranslation implements OnInit {

  @Input() data: any;
  isLoadingPreview = true;
  isLoading = true;
  conditions = {
    form: {
      condition: '',
      hint: '',
      accepted: false,
      LCU: '',
      LCD: undefined,
      qsAccepted: false,
      qsLCU: '',
      qsLCD: undefined,
      get showCondition(): boolean {
        return true;
      },
      showAccept: true
    },
    preCalc: {
      receiptNetto: 0.0,
      receiptVat: 0,
      receiptBrutto: 0.0,
      diffBrutto: 0.0,
      diffNetto: 0.0,
      diffVat: 0.0,
      originalBrutto: 0.0,
      originalNetto: 0.0,
      originalVat: 0.0,
      resultBrutto: 0.0,
      resultNetto: 0.0,
      resultVAT: 0.0,
      corrLength: 0,
    },
    header: 'Bitte vor Abschluss bestätigen:',
    data: [
      {
        condition:
          'Keine Erfassung der Rechnungs-Netto/-Bruttosumme',
        hint: 'Tab 1: Details - Felder: Brutto-/ Netto-Summe',
        accepted: false,
        LCU: '',
        LCD: undefined,
        qsAccepted: false,
        qsLCU: '',
        qsLCD: undefined,
        get showCondition(): boolean {
          return this.getCondition();
        },
        getCondition: (): boolean => {
          return (
            this.conditions.preCalc.receiptNetto === 0 ||
            this.conditions.preCalc.receiptBrutto === 0
          );
        },
        showAccept: true
      },
      {
        condition: 'Erfasste Rechnungspositionen Beträge ungleich Gesamtsumme',
        hint: 'Gesamtsumme der Stammdaten ist ungleich Tab 2 - Summe Originalwerte',
        accepted: false,
        LCU: '',
        LCD: undefined,
        qsAccepted: false,
        qsLCU: '',
        qsLCD: undefined,
        get showCondition(): boolean {
          return !this.getCondition();
        },
        getCondition: (): boolean => {
          return (
            (!(
                this.conditions.preCalc.receiptNetto === 0 ||
                this.conditions.preCalc.receiptBrutto === 0
              ) &&
              (
                (
                  Math.round((
                      (this.conditions.preCalc.receiptNetto - this.conditions.preCalc.originalNetto) + Number.EPSILON)
                    * 100
                  ) / 100) === 0
              )
            ) ||
            this.conditions.preCalc.corrLength === 0
          );
        },
        showAccept: true
      },
      {
        condition: 'Keine Rechnungspositionen erfasst.',
        hint: 'Tab 2: Position mit Orignalwert und ggf. Korrekturen',
        accepted: false,
        LCU: '',
        LCD: undefined,
        qsAccepted: false,
        get showCondition(): boolean {
          return this.getCondition();
        },
        getCondition: (): boolean => {
          return (
            this.conditions.preCalc.corrLength === 0
          );
        },
        showAccept: true
      },
      {
        condition: 'Summe des Freigabebetrags ist größer als die Belegsumme',
        hint: 'Positionen - Summe der Freigabebeträge > Summe Rechnungssumme',
        accepted: false,
        LCU: '',
        LCD: undefined,
        qsAccepted: false,
        qsLCU: '',
        qsLCD: undefined,
        get showCondition(): boolean {
          return this.getCondition();
        },
        getCondition: (): boolean => {
          return (
            this.conditions.preCalc.resultNetto < 0
          );
        },
        showAccept: true
      },
      {
        condition: 'Prüfungsergebnis erfassen',
        hint: 'Es wurde noch kein Prüfungsergebnis erfasst',
        accepted: false,
        LCU: '',
        LCD: undefined,
        qsAccepted: false,
        qsLCU: '',
        qsLCD: undefined,
        get showCondition(): boolean {
          return this.getCondition();
        },
        getCondition: (): boolean => {
          return !this.rcptData.data.rcptReviewReasons || this.rcptData.data.rcptReviewReasons.length === 0;
        },
        showAccept: false
      },
    ],
    canChangeState: (): boolean => {
      return ExcCoreModule.Array.ExistsObject(
          this.conditions.visibleConditions(),
          'accepted',
          false
        ) && !this.rcptData.data.rcptStatement;
    },
    visibleConditions(): any[] {
      return ExcCoreModule.Array.GetAll(this.data, 'showCondition', true);
    },
    acceptedAll(): boolean {
      const conditions = this.visibleConditions();
      return conditions.length > 0
        ? ExcCoreModule.Array.GetAll(conditions, 'accepted', false).length === 0
        : true;
    },
    reset(): void {
      const conditions = this.visibleConditions();
      conditions.forEach((condition: any) => {
        condition.accepted = false;
      });
    },
  };
  rcptData = {
    data: {} as any,
    correctionsData: [] as any[],
    correctionsSum: 0,
    originals: 0,


    preCalc: () => {
      const preCalc = this.conditions.preCalc;
      preCalc.diffNetto = this.calcDiffNetto(
        this.rcptData.getCorrSumme(1)
      );
      preCalc.diffBrutto = this.calcDiffBrutto(
        this.rcptData.getCorrSumme(1)
      );
      preCalc.diffVat = this.calcDiffVAT(
        this.rcptData.getCorrSumme(1)
      );

      preCalc.originalNetto = this.rcptData.originals;
      preCalc.originalBrutto = this.calcDiffBrutto(
        this.rcptData.originals
      );
      preCalc.originalVat = this.calcDiffVAT(
        this.rcptData.originals
      );
      preCalc.receiptVat = this.calcVAT();
      preCalc.receiptBrutto = this.calcBrutto();
      preCalc.receiptNetto = this.rcptData.data.rcptNetSum;
      preCalc.corrLength = this.rcptData.correctionsData.length;
    },
    loadData: (Receipt: any) => {
      this.rcptData.data = {...Receipt };
      if (this.rcptData.data.rcptStatement) {
        this.securityHandler.tokenPrefix = 'STATEMENT';
      }
      this.rcptData.data.rcptReviewReasons = this.rcptData.data.rcptReviewReasons
        ? JSON.parse(this.rcptData.data.rcptReviewReasons)
        : undefined;
      this.rcptData.data.rcptReviewHints = this.rcptData.data.rcptReviewHints
        ? JSON.parse(this.rcptData.data.rcptReviewHints)
        : undefined;

      this.currentUPT = Receipt.rcptUPT;
      this.currentStatusEnmIdent = Receipt.rcpt_enmIdent_ReceiptStatus;
      this.reportIsPicked = this.getPickStatus(Receipt);
      this.isLoading = false;
    },
    loadCorrections: (Corrections: any[]) => {
      this.rcptData.correctionsData = Corrections;
      this.rcptData.sumUpEntries();
      this.rcptData.sumUpOriginals();
      this.rcptData.preCalc();
    },
    sumUpEntries(): void {
      this.correctionsSum = 0;
      this.correctionsSum =
        this.correctionsData.reduce((sumCorr: number, correctionElement: any) => {
          if (correctionElement.rcptCorAmountCorr && correctionElement.rcptCorAmountCorr > 0) {
            return sumCorr + correctionElement.rcptCorAmountCorr;
          } else if (correctionElement.rcptCorValueCorr && correctionElement.rcptCorValueCorr > 0) {
            if (correctionElement.rcptCorMengeCorr && correctionElement.rcptCorMengeCorr !== 0) {
              return sumCorr + (
                correctionElement.rcptCorValueCorr * correctionElement.rcptCorMengeCorr
              );
            } else if (correctionElement.rcptCorMengeCorr === 0) {
              return sumCorr + correctionElement.rcptCorValueCorr;
            }
          } else {
            return sumCorr;
          }
        }, 0);
    },
    sumUpOriginals(): void {
      this.originals = 0;
      this.originals =
        this.correctionsData.reduce((sumOrig: number, originalElement: any) => {
          if (originalElement.rcptCorAmountOrig && originalElement.rcptCorAmountOrig > 0) {
            return sumOrig + originalElement.rcptCorAmountOrig;
          } else if (originalElement.rcptCorValueOrig && originalElement.rcptCorValueOrig > 0) {
            if (originalElement.rcptCorMengeOrig && originalElement.rcptCorMengeOrig !== 0) {
              return sumOrig + (
                originalElement.rcptCorValueOrig * originalElement.rcptCorMengeOrig
              );
            } else if (originalElement.rcptCorMengeOrig === 0) {
              return sumOrig + originalElement.rcptCorValueOrig;
            }
          } else {
            return sumOrig;
          }
        }, 0);
    },
    getCorrSumme(posNeg: number): number {
      if (this.data && this.data.length > 0) {
        return this.correctionsSum * posNeg;
      } else {
        return 0;
      }
    }
  };

  review = {
    rcptReviewComment: '',
    rcptCommentNext: '',
    rcptReviewDate: Date.now(),
    rcptReviewReasons: undefined as any ,
    rcptReviewHints: undefined as any,
    rcptSumTable: true,
    rcptPosTable: false
  };
  private _currentStatusEnmIdent = 0;
  get currentStatusEnmIdent(): number {
    return this._currentStatusEnmIdent;
  }
  set currentStatusEnmIdent(enmIdent: number) {
    this._currentStatusEnmIdent = enmIdent;
  }

  private _currentUPT = '';
  get currentUPT(): string {
    return this._currentUPT;
  }
  set currentUPT(UPT: string) {
    this._currentUPT = UPT;
  }

  private _currentResource: any;
  get currentResource(): any {
    return this._currentResource;
  }
  set currentResource(value: any) {
    this.isLoadingPreview = true;
    this._currentResource = value;
  }

  private _reportIsPicked = true;
  get reportIsPicked(): boolean {
    return this._reportIsPicked;
  }
  set reportIsPicked(value: boolean) {
    this._reportIsPicked = value;
  }

  securityHandler = {
    tokenPrefix: 'RECEIPT',
    maxEditableState: 3, // zur Prüfung
    pickedState: 4, // in Prüfung
    finalState: [10, 20],
    canEdit: (): boolean => {
      const actualState =
        this.currentStatusEnmIdent;

      if (!actualState) {
        return false;
      } else {
        if (actualState === 5) {
          return true;
        }

        if (
          !this.securityHandler.finalState.filter((fs) => fs === actualState)
        ) {
          return false; // Final State #Abgeschlossen
        } else if (
          this.securityHandler.noPowerUser() && // SV & Nicht zur Prüfung
          actualState < this.securityHandler.maxEditableState
        ) {
          return true;
        } else if (
          this.securityHandler.powerUser() && // EIS & Nicht zur Prüfung || Prüfung
          (actualState < this.securityHandler.maxEditableState ||
            actualState === this.securityHandler.pickedState)
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    canPick: () => { // Pick = Prüfung beginnen -> In Prüfung
      const actualState =
        this.currentStatusEnmIdent;

      return (
        this.securityHandler.powerUser() &&
        actualState === this.securityHandler.maxEditableState
      );
    },
    powerUser: () => {
      return this.excSecurity.isFeatured(this.securityHandler.tokenPrefix + 'CHECK');
    },
    noPowerUser: () => {
      return !this.excSecurity.isFeatured(this.securityHandler.tokenPrefix + 'CHECK') || this.securityHandler.powerUser();
    },
  };

  constructor(
    private dataSvc: DataService,
    public appSvc: ApplicationService,
    public excSecurity: ExcSecurityService,
    public overlayService: ExgOverlayService,
    private modal: ExgModalService,
    public excRest: ExcRestService,
    public enumSvc: EnumerationService) {
    super();
  }

  ngOnInit(): void {
    this.setPreviewType(this.data);
  }

  private setPreviewType(data: any): void {
    this.currentStatusEnmIdent = this.getStatusEnmIdent(data);
    this.currentUPT = this.getUPT(data);
    this.reportIsPicked = this.getPickStatus(data);

    if (data.cvID)        {
      this.currentResource = this.excRest.computeUrl('CalculationVersionR_Preview', {cvID: data.cvID });
    } else if (data.qverID) {
      this.currentResource = this.excRest.computeUrl('QuestionnaireVersionR_Summary_Report', {qverID: data.qverID});
    } else if (data.pdID)   {
      this.currentResource = this.excRest.computeUrl('PhotoDocumentationR_Preview', {pdID: data.pdID});
    } else if (data.rcptID) {
      if (data.rcptStatement) {
        this.currentResource = this.excRest.computeUrl('ReceiptR_Statement_review', { rcptID: data.rcptID});
        this.getReceiptData(data.rcptID);
      } else {
        this.currentResource = this.excRest.computeUrl('ReceiptR_Review', { rcptID: data.rcptID});
        this.getReceiptData(data.rcptID);
      }
    }
    if (data.cvID || data.qverID || data.pdID || data.rcptID) {
      this.isLoading = false;
      return;
    }

    /*ELSE*/
    this.modal.showToast(this.getRessource('Toast.GenericPreviewFail'), 'md-toast', 'fas fa-exclamation');
    this.overlayService.close();
  }

  private getReceiptData(rcptID: string): void {
    this.excRest
      .get(
        this.excRest.computeUrl('ReceiptR_Checkview', {
          rcptID,
        })
      )
      .subscribe((response: any) => {
        if (response?.success && response.data) {
          this.rcptData.loadData(response.data.Receipt);
          this.rcptData.loadCorrections(response.data.Corrections);
        } else {
          this.modal.showToast(this.getRessource('Toast.GenericPreviewFail'), 'md-toast', 'fas fa-exclamation');
          this.overlayService.close();
        }
      });
  }

  stopLoadingPDF(event: any): void {
    if (event) { this.isLoadingPreview = false; }
  }

  updateReportStatus(enmIdent: number, comment: string = ''): void {
    this.isLoading = true;
    let url = '';
    let payload = {};
    let enmAttribute = '';
    let UPTAttribute = '';

    if (this.data.cvID) {
      payload = { cvCalculationVersionStatus_enmIdent: enmIdent
                , cvUPT: this._currentUPT
                , stateChangeComment: comment};
      url = this.excRest.computeUrl('CalculationVersionU', {cvID: this.data.cvID});
      enmAttribute = 'cvCalculationVersionStatus_enmIdent';
      UPTAttribute = 'cvUPT';
    }
    if (this.data.qverID) {
      payload = { qverQuestionnaireVersionStatus_enmIdent: enmIdent
        , qverUPT: this.currentUPT
        , stateChangeComment: comment };
      url = this.excRest.computeUrl('QuestionnaireVersionU', {qverID: this.data.qverID});
      enmAttribute = 'qverQuestionnaireVersionStatus_enmIdent';
      UPTAttribute = 'qverUPT';
    }
    if (this.data.pdID) {
      payload = { pdPhotoDocumentationStatus_enmIdent: enmIdent
                , pdUPT: this.currentUPT
                , stateChangeComment: comment};
      url = this.excRest.computeUrl('PhotoDocumentationU', {pdID: this.data.pdID});
      enmAttribute = 'pdPhotoDocumentationStatus_enmIdent';
      UPTAttribute = 'pdUPT';
    }
    if (this.data.rcptID) {
      this.modal.showToast( this.getRessource('Toast.GenericStateChangeFail'), 'md-toast', 'fas fa-exclamation');
      return;
    }

    this.excRest.put(url, payload).subscribe((ret: any) => {
      if (ret && ret.success) {
        this.modal.showToast( this.getRessource('Toast.GenericStateChangeSuccess'), 'md-toast', 'fas fa-check-circle');
        this.currentStatusEnmIdent = ret.data[0][enmAttribute];
        this.currentUPT = ret.data[0][UPTAttribute];
        this.reportIsPicked = this.getPickStatus(ret.data[0]);
        this.isLoading = false;
      }
      else {
        this.isLoading = false;
        this.modal.showToast( this.getRessource('Toast.GenericStateChangeFail'), 'md-toast', 'fas fa-exclamation');
      }
    });
  }

  private getStatusEnmIdent(data: any): number {
    if (data?.cvID)   { return data.cvCalculationVersionStatus_enmIdent     ?? 0; }
    if (data?.qverID) { return data.qverQuestionnaireVersionStatus_enmIdent ?? 0; }
    if (data?.pdID)   { return data.pdPhotoDocumentationStatus_enmIdent     ?? 0; }
    if (data?.rcptID) { return data.rcpt_enmIdent_ReceiptStatus             ?? 0; }
    return 0;
  }

  private getUPT(data: any): string {
    if (data?.cvID)   { return data.cvUPT ?? ''; }
    if (data?.qverID) { return data.qverUPT ?? ''; }
    if (data?.pdID)   { return data.pdUPT ?? ''; }
    if (data?.rcptID) { return data.rcptUPT ?? ''; }
    return '';
  }

  private getPickStatus(data: any): boolean {
    if (data.cvID)   { return !!data.cvPicker || !!data.cvPickD || !!data.cvPickU; }
    if (data.qverID) { return !!data.qverPicker || !!data.qverPickD || !!data.qverPickU; }
    if (data.pdID)   { return !!data.pdPicker || !!data.pdPickD || !!data.pdPickU; }
    if (data.rcptID) { return !!data.rcptPicked || !!data.rcptPickedD || !!data.rcptPickedU; }
    return false;
  }

  private getEnmName(data: any): string {
    if (data.cvID)   { return data.cvCalculationVersionStatus_enmName ?? ''; }
    if (data.qverID) { return data.qverQuestionnaireVersionStatus_enmName ?? ''; }
    if (data.pdID)   { return data.pdPhotoDocumentationStatus_enmName ?? ''; }
    if (data.rcptID) { return data.rcpt_enmIdent_ReceiptStatus ?? ''; }
    return '';
  }

  openConfirmationModal(newEnmIdent: number, btnText: string): void {
    const enmName = this.getEnmName(this.data);
    const data = {
      currentEnmIdent: this.currentStatusEnmIdent
      , newEnmIdent
      , enmName
      , btnText
    };
    this.modal.show('ModalConfirmReportStateChangeComponent', data).subscribe(
      (evt: any) => {
        if (evt?.success) {
          this.updateReportStatus(newEnmIdent, evt.comment || '');
        }
      });
  }

  /*Receipt*/
  excCall_RcptChangeState(): void {
    this.isLoading = true;
    if (this.securityHandler.powerUser()) {
      this.excRest
        .put(
          this.excRest.computeUrl('ReceiptU_Review', {
            rcptID: this.rcptData.data.rcptID,
          }),
          {
            rcptUPT: this.currentUPT,
            rcptAccepted: null,
            rcptStateChange: true,
            rcptReviewDate: null,
            rcptReviewComment: null,
            rcptReviewReasons: null,
            rcptCommentNext: null,
          },
          {MetaInfo: {dataPaging: {pageNo: 0, pageSize: 0}}}
        )
        .subscribe((result: any) => {
          if (result?.success ) {
            this.modal.showToast( this.getRessource('Toast.GenericStateChangeSuccess'), 'md-toast', 'fas fa-check-circle');
            this.getReceiptData(result.data.Receipt.rcptID);
          }
          else {
            this.isLoading = false;
            this.modal.showToast( this.getRessource('Toast.GenericStateChangeFail'), 'md-toast', 'fas fa-exclamation');
          }
        });
    }
  }

  receiptReviewSave(
    cancelToken = false,
    stateChange?: boolean,
    accepted?: boolean
  ): void {
    if (!cancelToken && this.securityHandler.canEdit()) {

      if (this.review) {
        const review = this.review;
        this.excRest
          .put(
            this.excRest.computeUrl('ReceiptU_Review', {
              rcptID: this.rcptData.data.rcptID,
            }),
            {
              rcptUPT: this.currentUPT,
              rcptAccepted: accepted,
              rcptStateChange: stateChange,
              rcptReviewDate: review.rcptReviewDate,
              rcptReviewComment: review.rcptReviewComment,
              rcptReviewReasons: review.rcptReviewReasons,
              rcptReviewHints: review.rcptReviewHints,
              rcptCommentNext: review.rcptCommentNext,
              rcptPosTable: review.rcptPosTable,
              rcptSumTable: review.rcptSumTable,
            },
            {MetaInfo: {dataPaging: {pageNo: 0, pageSize: 0}}}
          )
          .subscribe((result: any) => {
            if (result?.success ) {
              this.modal.showToast( this.getRessource('Toast.GenericStateChangeSuccess'), 'md-toast', 'fas fa-check-circle');
              this.getReceiptData(result.data.Receipt.rcptID);
            }
            else {
              this.isLoading = false;
              this.modal.showToast( this.getRessource('Toast.GenericStateChangeFail'), 'md-toast', 'fas fa-exclamation');
            }
          });
      }
    }
  }

  receiptReview(
    btnText: string,
    stateChange?: boolean,
    accepted?: boolean
  ): void {
    if (
      this.conditions.canChangeState()
      &&
      (btnText === this.getRessource('review.proofIt') && stateChange && accepted === undefined)
    ) {
      return;
    }
    this.isLoading = true;
    this.modal
      .show('ReceiptCommentNextComponent', {
        modalHeader: this.getRessource('review.changeStateTitle', {btnText}),
        changeStateText: this.getRessource(
          `review.changeStateText.${
            this.currentStatusEnmIdent <= 2
              ? 'beforeProof'
              : accepted !== undefined
                ? 'beforeFinish'
                : 'beforeToSv'
          }`,
          {btnText}
        ),
        btnText,
        reviewClone: this.review,
        forceComment:
          this.currentStatusEnmIdent === 4 &&
          stateChange &&
          accepted === undefined,
      })
      .subscribe((ret: boolean) => {
        if (ret) {
          this.receiptReviewSave(false, stateChange, accepted);
          if (stateChange) {
            this.showMessageSomething(
              'Belegstatus NEU: ' +
              this.enumSvc.getEnumerationText(
                'ReceiptStatus',
                this.currentStatusEnmIdent
              ),
              'fal fa-clipboard-list-check',
              'md-toast bg-green'
            );
            if (accepted !== undefined) {
              if (accepted) {
                this.showMessageSomething(
                  'Beleg freigegeben',
                  'fal fa-clipboard-list-check',
                  'md-toast bg-green'
                );
              } else if (!accepted) {
                this.showMessageSomething(
                  'Beleg stoniert',
                  'fal fa-file-minus',
                  'md-toast bg-red'
                );
              }
            }
            if (this.securityHandler.canPick()) {
              this.pickReceiptReview();
            }
            this.isLoading = false;
          } else {
            this.showMessageSomething(
              'Bearbeitung gespeichert',
              'fal fa-clipboard-list',
              'md-toast'
            );
          }
          this.isLoading = false;
        } else {
          this.isLoading = false;
        }
      });
  }

  showMessageSomething(
    msg: string,
    icon: string,
    additionalClasses?: string | ''
  ): void {
    this.modal.showToast(msg, `md-toast ${additionalClasses}`, icon);
  }

  pickReceiptReview = (): void => {
    if (this.securityHandler.canPick()) {
      this.modal
        .showSimple(
          this.getRessource('Review'),
          this.getRessource('PickRcptText'),
          true,
          true,
          this.getRessource('PickRcptConfirm'),
          this.getRessource('PickRcptReject')
        )
        .subscribe((ret: boolean) => {
          if (ret) {
            this.pickReview();
          }
        });
    }
  }

  pickReview(): void {
    if (this.securityHandler.canPick()) {
      this.excCall_RcptChangeState();
      this.showMessageSomething(
        'Belegstatus NEU: ' +
        this.enumSvc.getEnumerationText(
          'ReceiptStatus',
          this.currentStatusEnmIdent
        ),
        'fal fa-clipboard-list-check',
        'md-toast bg-green'
      );
    }
  }

  receiptReviewU_RevokeState(btnText: string): void {
    this.modal
      .show('ReceiptCommentNextComponent', {
        modalHeader: this.getRessource('review.changeStateTitle', {btnText}),
        changeStateText: this.getRessource(
          `review.changeStateText.${
            this.currentStatusEnmIdent <= 2
              ? 'beforeProof'
              : 'beforeFinish'
          }`,
          {btnText}
        ),
        btnText,
        reviewClone: this.review,
        forceComment: true,
      })
      .subscribe((ret: boolean) => {
        if (ret) {
          const review = this.review;
          this.excRest
            .put(this.excRest.computeUrl('ReceiptU_RevokeState', {
              rcptID: this.rcptData.data.rcptID,
            }), {
              rcptUPT: this.currentUPT
              , rcptCommentNext: review.rcptCommentNext,
            }, {MetaInfo: {dataPaging: {pageNo: 0, pageSize: 0}}})
            .subscribe((result: any) => {
              if (result?.success && result) {
                this.modal.showToast( this.getRessource('Toast.GenericStateChangeSuccess'), 'md-toast', 'fas fa-check-circle');
                this.getReceiptData(result.data.Receipt.rcptID);
              }
              else {
                this.isLoading = false;
                this.modal.showToast( this.getRessource('Toast.GenericStateChangeFail'), 'md-toast', 'fas fa-check-circle');
              }
            });
        }
      });
  }

  calcDiffNetto(sumCorr?: number, rcptClone?: boolean): number {
    return this.getNetto(0, rcptClone) - this.getNetto(sumCorr, rcptClone);
  }

  getNetto(sumCorr?: number, rcptClone?: boolean): number {
    const rcpt = this.rcptData.data;
    return Number(rcpt?.rcptNetSum) - (sumCorr ? sumCorr : 0);
  }

  calcDiffVAT(sumCorr?: number, rcptClone?: boolean): number {
    return this.calcVAT(0, rcptClone) - this.calcVAT(sumCorr, rcptClone);
  }

  calcVAT(sumCorr?: number, rcptClone?: boolean): number {
    const rcpt = this.rcptData.data;
    const base: number = this.getNetto(sumCorr, rcptClone);

    return (base * rcpt?.rcptVATRate) / 100;
  }

  calcDiffBrutto(sumCorr?: number, rcptClone?: boolean): number {
    return this.calcBrutto(0, rcptClone) - this.calcBrutto(sumCorr, rcptClone);
  }

  calcBrutto(sumCorr?: number, rcptClone?: boolean): number {
    const base: number = this.getNetto(sumCorr, rcptClone);

    return this.calcVAT(sumCorr, rcptClone) + base;
  }

  togglePopupMenu(e: any, context: any): void {
    if (context
    && this.securityHandler.canEdit()
      && this.data.rcpt_enmIdent_ReceiptStatus < 10
      && this.data.rcpt_enmIdent_ReceiptStatus !== 3) {
      context.openAboveCenter(e);
    }
  }
}
